function revialSourceLine(text) {
  return String(text || "").split("\n")[0].trim();
}

function revialNormalizeText(text) {
  return String(text || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[’‘]/g, "'")
    .toLowerCase();
}

const REVIAL_PLACE_ORDER = [
  "Afrique du Sud",
  "Japon",
  "États-Unis",
  "France",
  "Pays-Bas",
  "Maldives",
  "Maroc",
];
const REVIAL_CITY_ORDER = [
  "Tokyo",
  "New York",
  "Forêt Notre-Dame",
  "Amsterdam",
  "Atoll de Seenu",
  "Paris",
  "Le Rozier",
  "Saint-Tropez",
  "Nikkō",
  "Ishigaki",
  "Fujikawaguchiko",
  "Grahamstown / Kariega",
  "Cape Town",
  "Kirkwood",
  "Brooklyn",
  "Marrakech",
];

function revialCityLabel(text) {
  const line = revialSourceLine(text);
  const normalized = revialNormalizeText(line);

  if (normalized.includes("paris") || normalized.includes("saint-eustache")) return "Paris";
  if (normalized.includes("foret notre-dame")) return "Forêt Notre-Dame";
  if (normalized.includes("le rozier")) return "Le Rozier";
  if (normalized.includes("saint-tropez")) return "Saint-Tropez";
  if (normalized.includes("omorinachi") || normalized.includes("shinjuku") || normalized.includes("ebisu")) return "Tokyo";
  if (normalized.includes("nikko")) return "Nikkō";
  if (normalized.includes("ishigaki")) return "Ishigaki";
  if (normalized.includes("fujikawaguchiko")) return "Fujikawaguchiko";
  if (normalized.includes("grahamstown") || normalized.includes("kariega")) return "Grahamstown / Kariega";
  if (normalized.includes("cape town")) return "Cape Town";
  if (normalized.includes("kirkwood")) return "Kirkwood";
  if (normalized.includes("brooklyn")) return "Brooklyn";
  if (normalized.includes("new york") || normalized.includes("financial district") || normalized.includes("midtown east") || normalized.includes("carnegie hill")) return "New York";
  if (normalized.includes("marrakech")) return "Marrakech";
  if (normalized.includes("rapenburg") || normalized.includes("amsterdam")) return "Amsterdam";
  if (normalized.includes("atoll de seenu")) return "Atoll de Seenu";

  return "Sans lieu";
}

function revialPlaceLabel(text) {
  const line = revialSourceLine(text);
  const normalized = revialNormalizeText(line);

  if (
    normalized.includes("paris") ||
    normalized.includes("saint-eustache") ||
    normalized.includes("foret notre-dame") ||
    normalized.includes("le rozier") ||
    normalized.includes("saint-tropez") ||
    normalized.includes("france")
  ) {
    return "France";
  }

  if (
    normalized.includes("omorinachi") ||
    normalized.includes("shinjuku") ||
    normalized.includes("ebisu") ||
    normalized.includes("nikko") ||
    normalized.includes("ishigaki") ||
    normalized.includes("fujikawaguchiko") ||
    normalized.includes("japon")
  ) {
    return "Japon";
  }

  if (
    normalized.includes("grahamstown") ||
    normalized.includes("kariega") ||
    normalized.includes("cape town") ||
    normalized.includes("kirkwood") ||
    normalized.includes("afrique du sud")
  ) {
    return "Afrique du Sud";
  }

  if (
    normalized.includes("brooklyn") ||
    normalized.includes("new york") ||
    normalized.includes("financial district") ||
    normalized.includes("midtown east") ||
    normalized.includes("carnegie hill") ||
    normalized.includes("etats-unis") ||
    normalized.includes("usa")
  ) {
    return "États-Unis";
  }

  if (normalized.includes("marrakech") || normalized.includes("maroc")) return "Maroc";
  if (normalized.includes("rapenburg") || normalized.includes("amsterdam") || normalized.includes("pays-bas")) return "Pays-Bas";
  if (normalized.includes("atoll de seenu") || normalized.includes("maldives")) return "Maldives";

  return "Sans lieu";
}

function revialOrderIndex(list, label) {
  const index = list.indexOf(label);
  return index === -1 ? list.length : index;
}

function revialCountryAnchor(country) {
  return `pays-${revialNormalizeText(country)
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "")}`;
}

function revialIsA3Format(format) {
  const normalized = String(format || "")
    .replace(/\s+/g, " ")
    .toLowerCase();

  return (normalized.includes("29,7") && normalized.includes("42")) || /30\s*[x×]\s*40/.test(normalized);
}

const REVIAL_PAPER_ASSET_VERSION = "20260922-authoritative-a3-a4-renders-v3";
const REVIAL_FRAME_MODEL_ASSET_VERSION = "20260922-restore-a4-models-v2";
const REVIAL_A3_FRAME_ASSET_VERSION = "20260923-live-verified-a3-v1";
const REVIAL_FRAME_IMAGE_ASSET_VERSION = "20260923-live-verified-hq-v1";
const REVIAL_NIKKO_A3_PAPER_ASSET_VERSION = "20260922-nikko-a3-confirmed-v4";

function revialPaperImageUrl(handle, format = "") {
  const data = window.REVIAL_LOCAL;
  const base = window.REVIAL_THEME_ASSET_BASE;
  if (!data || !base || !Array.isArray(data.layout) || !handle) return "";

  const item = data.layout.find((entry) => entry.handle === handle);
  if (!item?.localId) return "";

  const isA3 = revialIsA3Format(format);
  const assetName = isA3
    ? `${item.localId}-papier-a3-border.png`
    : `${item.localId}-papier-a4.png`;
  const version = isA3 && item.localId === "vente-28"
    ? REVIAL_NIKKO_A3_PAPER_ASSET_VERSION
    : REVIAL_PAPER_ASSET_VERSION;
  return `${base}${assetName}?v=${version}`;
}

function revialPaperImageDimensions(format = "") {
  return revialIsA3Format(format) ? { width: 2048, height: 2048 } : { width: 1080, height: 1920 };
}

function revialA3FrameMedia(handle) {
  const data = window.REVIAL_LOCAL;
  const item = data?.layout?.find((entry) => entry.handle === handle);
  if (!item?.localId) return null;
  return data.a3Frames?.[item.localId] || {
    image: `${item.localId}-a3-frame.png`,
    model: `${item.localId}-a3-frame.glb`,
  };
}

function revialA4FrameMedia(handle) {
  const data = window.REVIAL_LOCAL;
  const item = data?.layout?.find((entry) => entry.handle === handle);
  if (!item?.localId) return null;
  return data.a4Frames?.[item.localId] || {
    image: `${item.localId}-a4-frame.png`,
  };
}

function revialA3FrameImageUrl(handle) {
  const media = revialA3FrameMedia(handle);
  const base = window.REVIAL_THEME_ASSET_BASE;
  if (!media?.image) return "";
  if (/^(?:https?:|data:|\/)/i.test(media.image)) return media.image;
  return `${base}${media.image}?v=${REVIAL_FRAME_IMAGE_ASSET_VERSION}`;
}

function revialA4FrameImageUrl(handle) {
  const media = revialA4FrameMedia(handle);
  const base = window.REVIAL_THEME_ASSET_BASE;
  if (!media?.image) return "";
  if (/^(?:https?:|data:|\/)/i.test(media.image)) return media.image;
  return `${base}${media.image}?v=${REVIAL_FRAME_IMAGE_ASSET_VERSION}`;
}

function revialFrameModelUrl(handle, format = "") {
  const data = window.REVIAL_LOCAL;
  const base = window.REVIAL_THEME_ASSET_BASE;
  if (!data || !base || !Array.isArray(data.layout) || !handle) return "";

  const item = data.layout.find((entry) => entry.handle === handle);
  if (!item || !item.localId) return "";

  if (revialIsA3Format(format)) {
    const media = revialA3FrameMedia(handle);
    return media?.model ? `${base}${media.model}?v=${REVIAL_A3_FRAME_ASSET_VERSION}` : "";
  }

  return `${base}${item.localId}-papier-a4-cadre.glb?v=${REVIAL_FRAME_MODEL_ASSET_VERSION}`;
}

const REVIAL_ANALYTICS_PREFIX = "albiges_tom";
const REVIAL_ANALYTICS_QUEUE_LIMIT = 80;
const REVIAL_ANALYTICS_QUEUE = [];
const REVIAL_ANALYTICS_ONCE = new Set();

function revialPriceFromCents(value) {
  const cents = Number(value);
  if (!Number.isFinite(cents)) return undefined;
  return Math.round(cents) / 100;
}

function revialAnalyticsConsentAccepted() {
  try {
    return window.localStorage.getItem("albiges_cookie_consent") === "accepted";
  } catch (error) {
    return false;
  }
}

function revialWithCustomerPrivacy(callback) {
  const shopify = window.Shopify;
  if (!shopify) {
    callback(null);
    return;
  }

  if (shopify.customerPrivacy) {
    callback(shopify.customerPrivacy);
    return;
  }

  if (typeof shopify.loadFeatures !== "function") {
    callback(null);
    return;
  }

  shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (error) => {
    callback(error ? null : shopify.customerPrivacy);
  });
}

function revialSetTrackingConsent(allowed) {
  revialWithCustomerPrivacy((privacy) => {
    if (!privacy || typeof privacy.setTrackingConsent !== "function") return;
    privacy.setTrackingConsent(
      {
        analytics: allowed,
        marketing: allowed,
        preferences: allowed,
      },
      () => {}
    );
  });
}

function revialPageContext() {
  return {
    page_path: window.location.pathname,
    page_title: document.title,
    page_url: window.location.href,
    referrer: document.referrer || "",
    viewport_width: window.innerWidth,
    viewport_height: window.innerHeight,
  };
}

function revialProductPayloadFromElement(element) {
  if (!element) return {};
  const dataset = element.dataset || {};
  const handle = dataset.productHandle || dataset.handle || "";
  const local = window.REVIAL_LOCAL?.layout?.find((item) => item.handle === handle);
  const price = revialPriceFromCents(dataset.productPriceCents || dataset.linePriceCents);
  const payload = {
    product_id: dataset.productId || "",
    variant_id: dataset.variantId || "",
    item_id: handle || dataset.productId || "",
    item_name: dataset.productTitle || dataset.title || local?.title || "",
    item_handle: handle,
    local_id: local?.localId || "",
    series: dataset.productSeries || "",
    format: dataset.format || "",
    currency: dataset.productCurrency || "EUR",
    quantity: Number(dataset.quantity) || 1,
    value: price,
  };

  return Object.fromEntries(Object.entries(payload).filter(([, value]) => value !== "" && value !== undefined));
}

function revialCurrentProductPayload(productPage) {
  const base = revialProductPayloadFromElement(productPage);
  const checked = productPage?.querySelector("[data-revial-variant]:checked");
  if (!checked) return base;
  return {
    ...base,
    variant_id: checked.getAttribute("data-variant-id") || base.variant_id,
    format: checked.getAttribute("data-format") || base.format,
    value: revialPriceFromCents(checked.getAttribute("data-price-cents")) ?? base.value,
  };
}

function revialGaPayload(eventName, payload) {
  const value = typeof payload.value === "number" ? payload.value : undefined;
  const item = {
    item_id: payload.item_id || payload.item_handle || payload.product_id,
    item_name: payload.item_name,
    item_category: payload.series,
    item_variant: payload.format,
    price: value,
    quantity: payload.quantity || 1,
  };
  const cleanItem = Object.fromEntries(Object.entries(item).filter(([, entry]) => entry !== "" && entry !== undefined));
  const eventPayload = {
    currency: payload.currency || "EUR",
    value,
    items: cleanItem.item_id || cleanItem.item_name ? [cleanItem] : undefined,
    revial_event: eventName,
    page_path: payload.page_path,
    place: payload.place,
    city: payload.city,
    section: payload.section,
    interaction: payload.interaction,
  };
  return Object.fromEntries(Object.entries(eventPayload).filter(([, entry]) => entry !== "" && entry !== undefined));
}

function revialExternalEventName(eventName) {
  const map = {
    product_view: "view_item",
    product_select: "select_item",
    add_to_cart_submit: "add_to_cart",
    cart_view: "view_cart",
    checkout_start: "begin_checkout",
    drop_signup_submit: "sign_up",
    scroll_depth: "scroll",
  };
  return map[eventName] || `${REVIAL_ANALYTICS_PREFIX}_${eventName}`;
}

function revialSendExternalAnalytics(eventName, payload) {
  const eventPayload = {
    event: revialExternalEventName(eventName),
    revial_event: eventName,
    ...payload,
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(eventPayload);

  const gaPayload = revialGaPayload(eventName, payload);
  if (typeof window.gtag === "function") {
    window.gtag("event", revialExternalEventName(eventName), gaPayload);
  }

  if (typeof window.fbq === "function") {
    const metaEvents = {
      product_view: "ViewContent",
      add_to_cart_submit: "AddToCart",
      checkout_start: "InitiateCheckout",
      drop_signup_submit: "Lead",
    };
    const metaEvent = metaEvents[eventName];
    if (metaEvent) {
      window.fbq("track", metaEvent, gaPayload);
    } else {
      window.fbq("trackCustom", `${REVIAL_ANALYTICS_PREFIX}_${eventName}`, payload);
    }
  }

  if (window.ttq && typeof window.ttq.track === "function") {
    const tiktokEvents = {
      product_view: "ViewContent",
      add_to_cart_submit: "AddToCart",
      checkout_start: "InitiateCheckout",
      drop_signup_submit: "SubmitForm",
    };
    window.ttq.track(tiktokEvents[eventName] || `${REVIAL_ANALYTICS_PREFIX}_${eventName}`, gaPayload);
  }

  if (typeof window.pintrk === "function") {
    const pinterestEvents = {
      add_to_cart_submit: "addtocart",
      checkout_start: "checkout",
      drop_signup_submit: "lead",
    };
    const pinterestEvent = pinterestEvents[eventName];
    if (pinterestEvent) window.pintrk("track", pinterestEvent, gaPayload);
  }

  if (typeof window.clarity === "function") {
    window.clarity("event", `${REVIAL_ANALYTICS_PREFIX}_${eventName}`);
  }
}

function revialFlushAnalyticsQueue() {
  if (!revialAnalyticsConsentAccepted() || !window.ALBIGES_ANALYTICS_LOADED) return;
  while (REVIAL_ANALYTICS_QUEUE.length) {
    const item = REVIAL_ANALYTICS_QUEUE.shift();
    revialSendExternalAnalytics(item.eventName, item.payload);
  }
}

function revialTrack(eventName, payload = {}, options = {}) {
  const eventPayload = {
    ...revialPageContext(),
    ...payload,
    event_time: new Date().toISOString(),
  };

  if (options.once) {
    const key = `${eventName}:${options.once}`;
    if (REVIAL_ANALYTICS_ONCE.has(key)) return;
    REVIAL_ANALYTICS_ONCE.add(key);
  }

  if (window.Shopify?.analytics?.publish) {
    window.Shopify.analytics.publish(`${REVIAL_ANALYTICS_PREFIX}:${eventName}`, eventPayload);
  }

  let storedConsent = "";
  try {
    storedConsent = window.localStorage.getItem("albiges_cookie_consent") || "";
  } catch (error) {}

  if (storedConsent === "refused") return;

  if (!revialAnalyticsConsentAccepted() || !window.ALBIGES_ANALYTICS_LOADED) {
    REVIAL_ANALYTICS_QUEUE.push({ eventName, payload: eventPayload });
    if (REVIAL_ANALYTICS_QUEUE.length > REVIAL_ANALYTICS_QUEUE_LIMIT) REVIAL_ANALYTICS_QUEUE.shift();
    return;
  }

  revialSendExternalAnalytics(eventName, eventPayload);
}

function revialCartPayload() {
  const lines = [...document.querySelectorAll("[data-revial-cart-line]")].map(revialProductPayloadFromElement);
  const value = lines.reduce((total, line) => total + (Number(line.value) || 0), 0);
  return {
    value: Math.round(value * 100) / 100,
    currency: lines[0]?.currency || "EUR",
    item_count: lines.reduce((total, line) => total + (Number(line.quantity) || 0), 0),
    items: lines,
  };
}

function revialRect(item) {
  return {
    left: item.x,
    right: item.x + item.w,
    top: item.y,
    bottom: item.y + item.w * item.ratio,
  };
}

function revialOverlap(a, b) {
  const width = Math.max(0, Math.min(a.right, b.right) - Math.max(a.left, b.left));
  const height = Math.max(0, Math.min(a.bottom, b.bottom) - Math.max(a.top, b.top));
  return width * height;
}

function revialCaptionRect(item, placement) {
  const current = revialRect(item);
  const captionW = 18;
  const captionH = 5.5;
  const captionGap = 1.8;

  if (placement === "top") {
    return { left: current.left, right: current.left + captionW, top: current.top - captionGap - captionH, bottom: current.top - captionGap };
  }
  if (placement === "top-right") {
    return { left: current.right - captionW, right: current.right, top: current.top - captionGap - captionH, bottom: current.top - captionGap };
  }
  if (placement === "bottom-right") {
    return { left: current.right - captionW, right: current.right, top: current.bottom + captionGap, bottom: current.bottom + captionGap + captionH };
  }
  return { left: current.left, right: current.left + captionW, top: current.bottom + captionGap, bottom: current.bottom + captionGap + captionH };
}

function revialCaptionPlacement(item, items, wallHeight) {
  const preferredTop = item.x > 58 ? "top-right" : "top";
  const preferredBottom = item.x > 58 ? "bottom-right" : "bottom";
  const options = [preferredTop, preferredBottom].map((placement) => {
    const rect = revialCaptionRect(item, placement);
    const ownOverlap = revialOverlap(rect, revialRect(item));
    const overlap = items
      .filter((other) => other.handle !== item.handle)
      .reduce((total, other) => total + revialOverlap(rect, revialRect(other)), 0);
    const outOfBounds =
      Math.max(0, -rect.left) +
      Math.max(0, rect.right - 100) +
      Math.max(0, -rect.top) +
      Math.max(0, rect.bottom - wallHeight);
    const edgeComfort =
      Math.max(0, rect.left) +
      Math.max(0, 100 - rect.right) +
      Math.max(0, rect.top) +
      Math.max(0, wallHeight - rect.bottom);

    return {
      placement,
      outOfBounds,
      score: ownOverlap * 10000 + overlap * 100 + outOfBounds * 10000 - edgeComfort * 0.02,
    };
  });
  const inside = options.filter((option) => option.outOfBounds === 0);
  return (inside.length ? inside : options).sort((a, b) => a.score - b.score)[0].placement;
}

function revialInitPaperRenders() {
  const previewObserver = "IntersectionObserver" in window
    ? new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const paper = entry.target.querySelector(".revial-card__image--paper[data-preview-src]");
        if (paper) {
          paper.src = paper.dataset.previewSrc;
          delete paper.dataset.previewSrc;
        }
        observer.unobserve(entry.target);
      });
    }, { rootMargin: "200px 0px" })
    : null;
  document.querySelectorAll("[data-revial-editions-card], [data-revial-related-card]").forEach((card) => {
    const handle = card.getAttribute("data-handle");
    const paperUrl = revialPaperImageUrl(handle, "42 x 29,7 cm");
    const media = card.querySelector(".revial-card__media");
    const original = card.querySelector(".revial-card__image");
    if (!paperUrl || !media || !original || media.querySelector(".revial-card__image--paper")) return;

    media.querySelector(".revial-card__image--frame-preview")?.remove();

    const paper = document.createElement("img");
    paper.className = "revial-card__image revial-card__image--paper";
    if (previewObserver) paper.dataset.previewSrc = paperUrl;
    else paper.src = paperUrl;
    paper.alt = original.alt || "";
    paper.width = 2048;
    paper.height = 2048;
    paper.loading = "lazy";
    media.appendChild(paper);
    previewObserver?.observe(card);
  });

  document.querySelectorAll("[data-revial-product-page]").forEach((productPage) => {
    if (productPage.dataset.revialFormatMediaReady === "true") return;
    productPage.dataset.revialFormatMediaReady = "true";
    const handle = productPage.getAttribute("data-product-handle");
    const image = productPage.querySelector(".revial-product__paper-image");
    const frame = productPage.querySelector("[data-revial-product-frame-image]");
    const frameSlide = frame?.closest("[data-revial-carousel-slide]");
    const media = productPage.querySelector(".revial-product__media");
    const modelWrapper = productPage.querySelector("[data-revial-product-model]");
    const arWrapper = productPage.querySelector("[data-revial-ar]");
    const model = productPage.querySelector("[data-revial-model-viewer]");

    const frameA3 = revialA3FrameMedia(handle);
    const frameA4 = revialA4FrameMedia(handle);
    const viewport = productPage.querySelector("[data-revial-carousel-viewport]");
    const updateA3FrameLayout = () => {
      if (!frame || !viewport || productPage.dataset.revialFormatSize !== "A3" || !frameA3?.bounds) return;
      const { width, height, bounds } = frameA3;
      const area = viewport.getBoundingClientRect();
      if (!area.width || !area.height || !width || !height || !bounds.width || !bounds.height) return;
      const imageFit = Math.min(area.width / width, area.height / height);
      const frameFit = Math.min(area.width / bounds.width, area.height / bounds.height);
      frame.style.setProperty("--revial-a3-frame-scale", String(frameFit / imageFit));
      frame.style.setProperty("--revial-a3-frame-x", `${(width / 2 - bounds.x - bounds.width / 2) * frameFit}px`);
      frame.style.setProperty("--revial-a3-frame-y", `${(height / 2 - bounds.y - bounds.height / 2) * frameFit}px`);
    };

    if (frame && viewport && frameA3?.bounds && "ResizeObserver" in window) {
      new ResizeObserver(updateA3FrameLayout).observe(viewport);
    }

    model?.addEventListener("load", (event) => {
      const loadedUrl = event.detail?.url ? new URL(event.detail.url, window.location.href).href : "";
      const currentUrl = model.getAttribute("src")
        ? new URL(model.getAttribute("src"), window.location.href).href
        : "";
      if (loadedUrl && currentUrl && loadedUrl !== currentUrl) return;
      model.dataset.formatLoading = "false";
      model.setAttribute("aria-busy", "false");
      model.dismissPoster?.();
    });

    const updateFormatMedia = () => {
      const selected = productPage.querySelector("[data-revial-variant]:checked");
      const format = selected?.getAttribute("data-format") || "";
      const isA3 = revialIsA3Format(format);
      productPage.dataset.revialFormatSize = isA3 ? "A3" : "A4";
      const viewerFormat = productPage.querySelector("[data-revial-viewer-format]");
      if (viewerFormat) viewerFormat.textContent = isA3 ? "30 × 40 cm" : "20 × 30 cm";
      const frameA3Image = revialA3FrameImageUrl(handle);
      const frameA4Image = revialA4FrameImageUrl(handle);
      const frameMedia = isA3 ? frameA3 : frameA4;
      const frameImage = isA3 ? frameA3Image : frameA4Image;
      const paperUrl = revialPaperImageUrl(handle, format);
      if (image && paperUrl) {
        const paperDimensions = revialPaperImageDimensions(format);
        image.setAttribute("width", String(paperDimensions.width));
        image.setAttribute("height", String(paperDimensions.height));
        image.removeAttribute("srcset");
        image.removeAttribute("sizes");
        image.dataset.paperFormat = format || "A4";
        image.onerror = () => {
          image.onerror = null;
          image.src = productPage.dataset.productImage || image.src;
        };
        image.src = paperUrl;
      }
      if (frame && frameSlide) {
        frameSlide.hidden = !frameImage;
        if (frameImage) {
          frame.removeAttribute("srcset");
          frame.removeAttribute("sizes");
          frame.setAttribute("width", String(frameMedia?.width || (isA3 ? 3600 : 1080)));
          frame.setAttribute("height", String(frameMedia?.height || (isA3 ? 3000 : 1440)));
          frame.alt = `${productPage.getAttribute("data-product-title") || "Tirage"} encadré, format ${isA3 ? "30 × 40 cm" : "20 × 30 cm"}`;
          frame.dataset.frameFormat = isA3 ? "A3" : "A4";
          frame.onerror = () => {
            frameSlide.hidden = true;
          };
          frame.src = frameImage;
          updateA3FrameLayout();
        }
      }

      const explicitModelUrl = !isA3 ? media?.getAttribute("data-model-src") || "" : "";
      const modelUrl = revialFrameModelUrl(handle, format) || explicitModelUrl;
      if (!model || !modelWrapper) return;
      modelWrapper.hidden = !modelUrl;
      if (arWrapper) arWrapper.hidden = !modelUrl;
      if (modelUrl && model.getAttribute("src") !== modelUrl) {
        model.dataset.modelFormat = isA3 ? "A3" : "A4";
        model.dataset.formatLoading = "true";
        model.setAttribute("aria-busy", "true");
        model.setAttribute("poster", frameImage || paperUrl || image?.currentSrc || image?.src || "");
        model.showPoster?.();
        model.setAttribute("src", modelUrl);
      }
    };

    updateFormatMedia();
    productPage.querySelector("[data-revial-product-paper]")?.dispatchEvent(
      new CustomEvent("revial:carousel-show", { bubbles: true })
    );
    productPage.addEventListener("change", (event) => {
      if (!(event.target instanceof HTMLInputElement) || !event.target.matches("[data-revial-variant]")) return;
      const keepFrame = frameSlide?.classList.contains("is-active");
      updateFormatMedia();
      const activeSlide = keepFrame && !frameSlide.hidden ? frameSlide : productPage.querySelector("[data-revial-product-paper]");
      activeSlide?.dispatchEvent(new CustomEvent("revial:carousel-show", { bubbles: true }));
    });
  });
}

function revialInitCartFramePreviews() {
  document.querySelectorAll("[data-revial-cart-frame]").forEach((image) => {
    if (!(image instanceof HTMLImageElement) || image.dataset.revialCartFrameReady === "true") return;
    image.dataset.revialCartFrameReady = "true";

    const handle = image.getAttribute("data-product-handle");
    const isA3 = revialIsA3Format(image.getAttribute("data-format"));
    const frameUrl = isA3 ? revialA3FrameImageUrl(handle) : revialA4FrameImageUrl(handle);
    if (!frameUrl) return;

    const fallbackSrc = image.dataset.fallbackSrc || image.currentSrc || image.src;
    const fallback = () => {
      image.onerror = null;
      image.classList.remove("is-frame-preview");
      image.removeAttribute("data-frame-format");
      image.src = fallbackSrc;
    };

    image.onerror = fallback;
    image.src = frameUrl;
    image.classList.add("is-frame-preview");
    image.dataset.frameFormat = isA3 ? "A3" : "A4";
    image.alt = `${image.alt.replace(/ encadré$/, "")} - aperçu encadré ${isA3 ? "30 × 40 cm" : "20 × 30 cm"}`;
  });
}

function revialInitProductCarousels() {
  document.querySelectorAll("[data-revial-product-carousel]").forEach((carousel) => {
    if (carousel.getAttribute("data-revial-carousel-ready") === "true") return;

    const viewport = carousel.querySelector("[data-revial-carousel-viewport]");
    const previous = carousel.querySelector("[data-revial-carousel-prev]");
    const next = carousel.querySelector("[data-revial-carousel-next]");
    const status = carousel.querySelector("[data-revial-carousel-status]");
    const current = carousel.querySelector("[data-revial-carousel-current]");
    const total = carousel.querySelector("[data-revial-carousel-total]");
    if (!viewport) return;

    carousel.setAttribute("data-revial-carousel-ready", "true");

    let index = 0;

    const allSlides = () => Array.from(carousel.querySelectorAll("[data-revial-carousel-slide]"));
    const visibleSlides = () => allSlides().filter((slide) => !slide.hidden);

    const update = (requestedIndex = index) => {
      const slides = visibleSlides();
      if (!slides.length) return;

      index = Math.min(Math.max(requestedIndex, 0), slides.length - 1);

      allSlides().forEach((slide) => {
        const active = slide === slides[index];
        slide.classList.toggle("is-active", active);
        slide.setAttribute("aria-hidden", active ? "false" : "true");
      });

      const previousHidden = slides.length <= 1 || index === 0;
      const nextHidden = slides.length <= 1 || index === slides.length - 1;
      if (previous && previous.hidden !== previousHidden) previous.hidden = previousHidden;
      if (next && next.hidden !== nextHidden) next.hidden = nextHidden;
      if (current && total) {
        current.textContent = String(index + 1);
        total.textContent = String(slides.length);
      } else if (status) {
        status.textContent = `Image ${index + 1} sur ${slides.length}`;
      }
    };

    previous?.addEventListener("click", () => update(index - 1));
    next?.addEventListener("click", () => update(index + 1));

    let touchStartX = null;
    let touchStartY = null;
    viewport.addEventListener("touchstart", (event) => {
      const touch = event.touches[0];
      if (!touch) return;
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
    }, { passive: true });
    viewport.addEventListener("touchend", (event) => {
      if (touchStartX === null || touchStartY === null) return;
      const touch = event.changedTouches[0];
      if (!touch) return;
      const deltaX = touch.clientX - touchStartX;
      const deltaY = touch.clientY - touchStartY;
      touchStartX = null;
      touchStartY = null;
      if (Math.abs(deltaX) < 48 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.15) return;
      update(index + (deltaX < 0 ? 1 : -1));
    }, { passive: true });
    viewport.addEventListener("touchcancel", () => {
      touchStartX = null;
      touchStartY = null;
    }, { passive: true });

    carousel.addEventListener("revial:carousel-show", (event) => {
      const target = event.target instanceof Element ? event.target.closest("[data-revial-carousel-slide]") : null;
      const slides = visibleSlides();
      const slideIndex = target ? slides.indexOf(target) : -1;
      if (slideIndex >= 0) update(slideIndex);
    });

    update(0);
  });
}

function revialInitProductForms() {
  document.addEventListener("change", (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (!input.matches("[data-revial-variant]")) return;

    const form = input.closest("[data-product-form]");
    if (!form) return;

    const price = input.getAttribute("data-price");
    const priceTarget = form.querySelector("[data-selected-price]");
    if (price && priceTarget) priceTarget.textContent = price;

    const available = input.getAttribute("data-available") === "true";
    const productPage = input.closest("[data-revial-product-page]");
    const availability = productPage?.querySelector(".revial-product__availability");
    const viewerFormat = productPage?.querySelector("[data-revial-viewer-format]");
    if (availability) availability.textContent = available ? "Disponible" : "Indisponible";
    if (viewerFormat) viewerFormat.textContent = revialIsA3Format(input.getAttribute("data-format") || "") ? "30 × 40 cm" : "20 × 30 cm";

    const submit = form.querySelector("[data-revial-add-to-cart]");
    if (submit) {
      submit.disabled = !available;
      submit.textContent = available ? "Ajouter au panier" : "Indisponible";
    }
  });
}

function revialInitGalleryWalls() {
  const data = window.REVIAL_LOCAL;
  if (!data || !Array.isArray(data.layout)) return;

  const layout = new Map(data.layout.map((item) => [item.handle, item]));
  const sortedLayout = [...data.layout].sort((a, b) => a.y - b.y || a.x - b.x);
  const computedWallHeight = Math.max(0, ...data.layout.map((item) => item.y + item.w * item.ratio)) + 6;
  const wallHeight = Number(data.localWallHeight) || computedWallHeight;

  document.querySelectorAll("[data-revial-wall]").forEach((wall) => {
    const desktop = wall.querySelector("[data-revial-wall-desktop]");
    const desktopItems = [...wall.querySelectorAll("[data-revial-wall-item]")];
    const mobileItems = [...wall.querySelectorAll("[data-revial-wall-mobile-item]")];

    if (desktop) desktop.style.height = `${wallHeight}cqw`;

    desktopItems.forEach((element) => {
      const handle = element.getAttribute("data-handle");
      const item = handle ? layout.get(handle) : null;
      if (!item) {
        element.hidden = true;
        return;
      }

      element.style.left = `${item.x}%`;
      element.style.top = `${item.y}cqw`;
      element.style.width = `${item.w}%`;
      element.style.zIndex = String(item.z);

      const caption = element.querySelector(".revial-wall__caption");
      if (caption) {
        const placement = revialCaptionPlacement(item, data.layout, wallHeight);
        caption.classList.add(`revial-wall__caption--${placement}`);
      }

      element.addEventListener("mouseenter", () => {
        element.style.zIndex = "200";
      });
      element.addEventListener("mouseleave", () => {
        element.style.zIndex = String(item.z);
      });
      element.addEventListener("focus", () => {
        element.style.zIndex = "200";
      });
      element.addEventListener("blur", () => {
        element.style.zIndex = String(item.z);
      });
    });

    mobileItems
      .sort((a, b) => {
        const aItem = layout.get(a.getAttribute("data-handle"));
        const bItem = layout.get(b.getAttribute("data-handle"));
        return sortedLayout.indexOf(aItem) - sortedLayout.indexOf(bItem);
      })
      .forEach((element) => {
        element.parentElement?.appendChild(element);
        element.addEventListener(
          "touchstart",
          () => {
            mobileItems.forEach((item) => {
              if (item !== element) item.classList.remove("is-touched");
            });
            element.classList.add("is-touched");
          },
          { passive: true }
        );
      });
  });
}

function revialInitEditions() {
  document.querySelectorAll("[data-revial-editions]").forEach((root) => {
    const source = root.querySelector("[data-revial-editions-source]");
    const output = root.querySelector("[data-revial-editions-output]");
    const countryNav = root.closest(".revial-editions")?.querySelector("[data-revial-country-nav]");
    const countryNavList = countryNav?.querySelector("[data-revial-country-nav-list]");
    if (!source || !output) return;

    const cards = [...source.querySelectorAll("[data-revial-editions-card]")];
    const grouped = new Map();

    cards.forEach((card) => {
      const sourceText = card.getAttribute("data-source") || card.getAttribute("data-title") || "";
      const place = revialPlaceLabel(sourceText);
      const city = revialCityLabel(sourceText);
      card.dataset.revialPlace = place;
      card.dataset.revialCity = city;
      if (!grouped.has(place)) grouped.set(place, []);
      grouped.get(place).push({ city, sourceText, card });
    });

    const places = [...grouped.entries()].sort(([a, aItems], [b, bItems]) => {
      return (
        revialOrderIndex(REVIAL_PLACE_ORDER, a) - revialOrderIndex(REVIAL_PLACE_ORDER, b) ||
        bItems.length - aItems.length ||
        a.localeCompare(b, "fr")
      );
    });

    output.innerHTML = "";
    if (countryNavList) countryNavList.innerHTML = "";

    places.forEach(([place, items], placeIndex) => {
      const section = document.createElement("section");
      const reversed = placeIndex % 2 === 1 ? " revial-place--reversed" : "";
      section.className = `revial-place${reversed}`;
      section.id = revialCountryAnchor(place);

      const intro = document.createElement("div");
      intro.innerHTML = `<h2 class="revial-place__title">${place}</h2><p class="revial-place__count">${items.length} edition${items.length > 1 ? "s" : ""}</p>`;

      const citiesWrap = document.createElement("div");
      const cityMap = new Map();
      items
        .sort((a, b) => a.sourceText.localeCompare(b.sourceText, "fr"))
        .forEach((item) => {
          if (!cityMap.has(item.city)) cityMap.set(item.city, []);
          cityMap.get(item.city).push(item);
        });

      [...cityMap.entries()]
        .sort(([a, aItems], [b, bItems]) => {
          return (
            revialOrderIndex(REVIAL_CITY_ORDER, a) - revialOrderIndex(REVIAL_CITY_ORDER, b) ||
            bItems.length - aItems.length ||
            a.localeCompare(b, "fr")
          );
        })
        .forEach(([city, cityItems]) => {
          const cityNode = document.createElement("div");
          cityNode.className = "revial-city";
          const title = document.createElement("h3");
          title.className = "revial-city__title";
          title.textContent = city;
          const grid = document.createElement("div");
          grid.className = "revial-grid";
          cityItems.forEach((item) => grid.appendChild(item.card));
          cityNode.append(title, grid);
          citiesWrap.appendChild(cityNode);
        });

      section.append(intro, citiesWrap);
      output.appendChild(section);

      if (countryNavList && place !== "Sans lieu") {
        const countryLink = document.createElement("a");
        countryLink.className = "revial-editions__country-nav-link";
        countryLink.href = `#${section.id}`;
        countryLink.textContent = place;
        countryNavList.appendChild(countryLink);
      }
    });

    if (countryNav && countryNavList?.children.length > 0) countryNav.hidden = false;
  });
}

function revialParseFormat(value) {
  const match = String(value || "").match(/([0-9]+(?:[,.][0-9]+)?)\s*x\s*([0-9]+(?:[,.][0-9]+)?)/i);
  if (!match) return { width: 40, height: 50, label: value || "Format" };
  return {
    width: Number(match[1].replace(",", ".")),
    height: Number(match[2].replace(",", ".")),
    label: value,
  };
}

function revialSelectedFormat(productPage) {
  const checked = productPage.querySelector("[data-revial-variant]:checked");
  return revialParseFormat(checked?.getAttribute("data-format"));
}

function revialInitAugmentedReality() {
  document.querySelectorAll("[data-revial-product-page]").forEach((productPage) => {
    const wrapper = productPage.querySelector("[data-revial-ar]");
    const open = productPage.querySelector("[data-revial-ar-open]");
    const note = productPage.querySelector("[data-revial-ar-note]");
    const model = productPage.querySelector("[data-revial-model-viewer]");
    if (!open || !model || !model.getAttribute("src")) return;
    if (wrapper) wrapper.hidden = false;

    const defaultText = open.textContent.trim();
    const mobileQuery = window.matchMedia("(hover: none) and (pointer: coarse)");

    function isMobileExperience() {
      const userAgent = window.navigator.userAgent || "";
      return mobileQuery.matches || /Android|iPhone|iPad|iPod/i.test(userAgent);
    }

    function updateAvailability() {
      if (!wrapper) return;
      const mobile = isMobileExperience();
      wrapper.classList.toggle("revial-ar--mobile", mobile);
      wrapper.classList.toggle("revial-ar--desktop", !mobile);
      open.hidden = !mobile;

      if (note) {
        note.textContent = mobile
          ? "Ouvrez la realite augmentee depuis votre camera pour visualiser le cadre dans l'espace."
          : "La visualisation en realite augmentee est disponible sur mobile compatible.";
      }
    }

    function temporaryText(text) {
      open.textContent = text;
      window.setTimeout(() => {
        open.textContent = defaultText;
      }, 2200);
    }

    function activate() {
      revialTrack(
        "ar_open",
        {
          ...revialCurrentProductPayload(productPage),
          model_src: model.getAttribute("src"),
        },
        { once: `ar:${model.getAttribute("src")}` }
      );

      if (typeof model.activateAR === "function") {
        if (model.loaded === false || model.dataset.formatLoading === "true") {
          temporaryText("Chargement 3D");
          return;
        }

        if (model.canActivateAR === false) {
          temporaryText("AR disponible sur mobile");
          return;
        }

        const activation = model.activateAR();
        if (activation && typeof activation.catch === "function") {
          activation.catch(() => temporaryText("AR disponible sur mobile"));
        }
        return;
      }

      temporaryText("AR disponible sur mobile");
    }

    updateAvailability();
    if (typeof mobileQuery.addEventListener === "function") {
      mobileQuery.addEventListener("change", updateAvailability);
    } else if (typeof mobileQuery.addListener === "function") {
      mobileQuery.addListener(updateAvailability);
    }

    model.addEventListener("ar-status", (event) => {
      revialTrack(
        "ar_status",
        {
          ...revialCurrentProductPayload(productPage),
          status: event.detail?.status || "",
        },
        { once: `ar-status:${event.detail?.status || ""}:${model.getAttribute("src")}` }
      );

      if (event.detail?.status === "failed") {
        temporaryText("AR disponible sur mobile");
      }
    });

    model.addEventListener("load", () => {
      revialTrack(
        "model_viewer_loaded",
        {
          ...revialCurrentProductPayload(productPage),
          model_src: model.getAttribute("src"),
        },
        { once: `model-loaded:${model.getAttribute("src")}` }
      );
    });

    model.addEventListener("camera-change", () => {
      revialTrack(
        "model_viewer_interaction",
        {
          ...revialCurrentProductPayload(productPage),
          model_src: model.getAttribute("src"),
        },
        { once: `model-interaction:${model.getAttribute("src")}` }
      );
    });

    model.addEventListener("error", () => {
      revialTrack(
        "model_viewer_error",
        {
          ...revialCurrentProductPayload(productPage),
          model_src: model.getAttribute("src"),
        },
        { once: `model-error:${model.getAttribute("src")}` }
      );
    });

    open.addEventListener("click", activate);
  });
}

function revialArtworkPayloadFromNode(node, section) {
  const wrapper = node.closest("[data-revial-editions-card], [data-revial-wall-item], [data-revial-wall-mobile-item]");
  const link = wrapper?.querySelector("[data-revial-product-link]") || node.closest("[data-revial-product-link]");
  const payload = {
    ...revialProductPayloadFromElement(link || wrapper),
    section,
    place: wrapper?.dataset.revialPlace || "",
    city: wrapper?.dataset.revialCity || "",
  };
  return Object.fromEntries(Object.entries(payload).filter(([, value]) => value !== "" && value !== undefined));
}

function revialInitAnalyticsEvents() {
  revialTrack("page_context", {
    template: document.body.className.match(/revial-template-([^\s]+)/)?.[1] || "",
  });

  const productPage = document.querySelector("[data-revial-product-page]");
  if (productPage) {
    revialTrack("product_view", revialCurrentProductPayload(productPage), { once: `product:${productPage.dataset.productHandle}` });
  }

  if (document.querySelector(".revial-cart")) {
    revialTrack("cart_view", revialCartPayload(), { once: `cart:${window.location.pathname}` });
  }

  const scrollDepths = [25, 50, 75, 90];
  const trackedDepths = new Set();
  let scrollScheduled = false;
  function trackScrollDepth() {
    scrollScheduled = false;
    const scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    const depth = Math.round((window.scrollY / scrollable) * 100);
    scrollDepths.forEach((threshold) => {
      if (depth >= threshold && !trackedDepths.has(threshold)) {
        trackedDepths.add(threshold);
        revialTrack("scroll_depth", { depth_percent: threshold }, { once: `scroll:${window.location.pathname}:${threshold}` });
      }
    });
  }

  window.addEventListener(
    "scroll",
    () => {
      if (scrollScheduled) return;
      scrollScheduled = true;
      window.requestAnimationFrame(trackScrollDepth);
    },
    { passive: true }
  );

  document.addEventListener("change", (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches("[data-revial-variant]")) return;
    const currentProductPage = input.closest("[data-revial-product-page]");
    if (!currentProductPage) return;
    revialTrack("format_select", revialCurrentProductPayload(currentProductPage));
  });

  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const currentProductPage = form.closest("[data-revial-product-page]");
    if (currentProductPage && form.matches("[data-product-form]")) {
      revialTrack("add_to_cart_submit", revialCurrentProductPayload(currentProductPage));
      return;
    }

    if (form.matches("[data-revial-wait-form]")) {
      revialTrack("drop_signup_submit", { method: "shopify_customer_form", form: "drop_waitlist" });
      return;
    }

    if (form.matches("[data-revial-popup-form]")) {
      revialTrack("drop_signup_submit", { method: "shopify_customer_form", form: "site_popup" });
    }
  });

  document.addEventListener("click", (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const checkout = target.closest("[data-revial-checkout-button]");
    if (checkout) {
      revialTrack("checkout_start", revialCartPayload());
      return;
    }

    const nav = target.closest("[data-revial-nav-link]");
    if (nav) {
      revialTrack("nav_click", {
        nav_item: nav.getAttribute("data-nav-item") || nav.textContent.trim(),
        destination: nav.getAttribute("href") || "",
      });
      return;
    }

    const social = target.closest("[data-revial-social-link]");
    if (social) {
      revialTrack("social_click", {
        network: social.getAttribute("data-network") || social.textContent.trim().toLowerCase(),
        destination: social.getAttribute("href") || "",
      });
      return;
    }

    const legal = target.closest("[data-revial-legal-link]");
    if (legal) {
      revialTrack("legal_link_click", {
        legal_item: legal.getAttribute("data-legal-item") || legal.textContent.trim(),
        destination: legal.getAttribute("href") || "",
      });
      return;
    }

    const galleryItem = target.closest("[data-revial-wall-item], [data-revial-wall-mobile-item]");
    if (galleryItem) {
      revialTrack("product_select", revialArtworkPayloadFromNode(galleryItem, "gallery"));
      return;
    }

    const editionCard = target.closest("[data-revial-editions-card]");
    if (editionCard) {
      revialTrack("product_select", revialArtworkPayloadFromNode(editionCard, "editions"));
    }
  });

  const hoverTracked = new WeakSet();
  function trackPaperHover(event) {
    const target = event.target instanceof Element ? event.target : null;
    const card = target?.closest("[data-revial-editions-card]");
    if (!card || hoverTracked.has(card)) return;
    hoverTracked.add(card);
    revialTrack("paper_render_preview", revialArtworkPayloadFromNode(card, "editions"), { once: `paper:${card.getAttribute("data-handle")}` });
  }

  document.addEventListener("mouseenter", trackPaperHover, true);
  document.addEventListener("touchstart", trackPaperHover, { passive: true });
}

function revialLoadScript(src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.async = true;
    script.src = src;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

let revialModelViewerPromise;
function revialEnsureModelViewer() {
  if (window.customElements?.get("model-viewer")) return Promise.resolve();
  if (revialModelViewerPromise) return revialModelViewerPromise;

  const base = window.REVIAL_THEME_ASSET_BASE || "";
  revialModelViewerPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.type = "module";
    script.src = `${base}model-viewer.min.js`;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
  return revialModelViewerPromise;
}

function revialInitModelViewerLoader() {
  const viewers = [...document.querySelectorAll("[data-revial-product-model]")];
  if (!viewers.length) return;

  const load = () => revialEnsureModelViewer().catch(() => {});
  viewers.forEach((viewer) => {
    viewer.addEventListener("pointerenter", load, { once: true });
    viewer.addEventListener("touchstart", load, { once: true, passive: true });
  });
  document.querySelectorAll("[data-revial-ar-open]").forEach((button) => {
    button.addEventListener("pointerdown", load, { once: true });
  });

  if (!("IntersectionObserver" in window)) {
    load();
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    if (!entries.some((entry) => entry.isIntersecting)) return;
    observer.disconnect();
    load();
  }, { rootMargin: "300px 0px" });
  viewers.forEach((viewer) => observer.observe(viewer));
}

function revialLoadAnalytics() {
  if (window.ALBIGES_ANALYTICS_LOADED) return;

  const ids = window.ALBIGES_ANALYTICS_IDS || {};
  window.ALBIGES_ANALYTICS_LOADED = true;

  if (ids.gtm) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    revialLoadScript(`https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(ids.gtm)}`).catch(() => {});
  }

  if (ids.google) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    revialLoadScript(`https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(ids.google)}`)
      .then(() => {
        window.gtag("js", new Date());
        window.gtag("config", ids.google);
      })
      .catch(() => {});
  }

  if (ids.meta) {
    window.fbq = window.fbq || function fbq() {
      window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
    };
    if (!window.fbq.queue) window.fbq.queue = [];
    window.fbq.loaded = true;
    window.fbq.version = "2.0";
    revialLoadScript("https://connect.facebook.net/en_US/fbevents.js")
      .then(() => {
        window.fbq("init", ids.meta);
        window.fbq("track", "PageView");
      })
      .catch(() => {});
  }

  if (ids.tiktok) {
    window.TiktokAnalyticsObject = "ttq";
    const ttq = window.ttq = window.ttq || [];
    ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"];
    ttq.setAndDefer = function setAndDefer(target, method) {
      target[method] = function deferred() {
        target.push([method].concat(Array.prototype.slice.call(arguments, 0)));
      };
    };
    ttq.methods.forEach((method) => ttq.setAndDefer(ttq, method));
    ttq.load = function load(pixelId) {
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=${encodeURIComponent(pixelId)}&lib=ttq`;
      document.head.appendChild(script);
    };
    ttq.load(ids.tiktok);
    ttq.page();
  }

  if (ids.pinterest) {
    window.pintrk = window.pintrk || function pintrk() {
      window.pintrk.queue.push(Array.prototype.slice.call(arguments));
    };
    window.pintrk.queue = window.pintrk.queue || [];
    window.pintrk.version = "3.0";
    revialLoadScript("https://s.pinimg.com/ct/core.js")
      .then(() => {
        window.pintrk("load", ids.pinterest);
        window.pintrk("page");
      })
      .catch(() => {});
  }

  if (ids.clarity) {
    window.clarity = window.clarity || function clarity() {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };
    revialLoadScript(`https://www.clarity.ms/tag/${encodeURIComponent(ids.clarity)}`).catch(() => {});
  }

  revialFlushAnalyticsQueue();
}

function revialInitCookieConsent() {
  const banner = document.querySelector("[data-albiges-cookie]");
  const ids = window.ALBIGES_ANALYTICS_IDS || {};
  const hasAnalytics = Object.values(ids).some(Boolean);
  if (!hasAnalytics) return;

  const key = "albiges_cookie_consent";
  const stored = window.localStorage.getItem(key);
  const showBanner = () => {
    if (banner) banner.hidden = false;
  };

  document.querySelectorAll("[data-albiges-cookie-reset]").forEach((button) => {
    button.addEventListener("click", () => {
      window.localStorage.removeItem(key);
      showBanner();
      revialTrack("cookie_preferences_reopened", { interaction: "footer_reset" });
    });
  });

  document.addEventListener("visitorConsentCollected", (event) => {
    if (event.detail?.analyticsAllowed) {
      try {
        window.localStorage.setItem(key, "accepted");
      } catch (error) {}
      revialLoadAnalytics();
      revialFlushAnalyticsQueue();
    }
  });

  if (stored === "accepted") {
    revialLoadAnalytics();
    return;
  }

  if (!banner || stored === "refused") return;

  showBanner();

  const accept = banner.querySelector("[data-albiges-cookie-accept]");
  const refuse = banner.querySelector("[data-albiges-cookie-refuse]");

  accept?.addEventListener("click", () => {
    window.localStorage.setItem(key, "accepted");
    banner.hidden = true;
    revialSetTrackingConsent(true);
    revialTrack("cookie_consent", { consent: "accepted" });
    revialLoadAnalytics();
    revialFlushAnalyticsQueue();
  });

  refuse?.addEventListener("click", () => {
    window.localStorage.setItem(key, "refused");
    banner.hidden = true;
    revialSetTrackingConsent(false);
    REVIAL_ANALYTICS_QUEUE.length = 0;
    revialTrack("cookie_consent", { consent: "refused" });
  });
}

function revialInitEmailPopup() {
  const popup = document.querySelector("[data-revial-email-popup]");
  if (!popup || window.location.pathname.split("/").filter(Boolean).pop() === "cart") return;

  const storageKey = "albiges_tom_email_popup";
  const sessionKey = "albiges_tom_email_popup_seen";
  const forceOpen = new URLSearchParams(window.location.search).get("revial_email_popup") === "1";
  const form = popup.querySelector("[data-revial-popup-form]");
  const input = popup.querySelector("input[type='email']");
  const dismissControls = popup.querySelectorAll("[data-revial-email-popup-dismiss]");

  const isSubscribed = () => {
    try {
      const stored = window.localStorage.getItem(storageKey);
      if (!stored) return false;
      if (stored === "subscribed") return true;
      const parsed = JSON.parse(stored);
      return parsed?.state === "subscribed";
    } catch (error) {
      return false;
    }
  };

  const setSubscribed = () => {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify({ state: "subscribed", savedAt: Date.now() }));
    } catch (error) {}
  };

  const hasShownThisSession = () => {
    try {
      return window.sessionStorage.getItem(sessionKey) === "true";
    } catch (error) {
      return false;
    }
  };

  const markSessionSeen = () => {
    try {
      window.sessionStorage.setItem(sessionKey, "true");
    } catch (error) {}
  };

  const close = () => {
    popup.hidden = true;
    popup.setAttribute("aria-hidden", "true");
  };

  if (window.location.search.includes("customer_posted=true")) {
    setSubscribed();
    return;
  }

  if (!forceOpen && (isSubscribed() || hasShownThisSession())) return;

  window.setTimeout(() => {
    if (!forceOpen && (isSubscribed() || hasShownThisSession())) return;
    markSessionSeen();
    popup.hidden = false;
    popup.setAttribute("aria-hidden", "false");
    input?.focus({ preventScroll: true });
  }, 20000);

  dismissControls.forEach((control) => {
    control.addEventListener("click", () => {
      close();
    });
  });

  form?.addEventListener("submit", () => {
    setSubscribed();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape" || popup.hidden) return;
    close();
  });
}

document.addEventListener("DOMContentLoaded", () => {
  revialInitPaperRenders();
  revialInitCartFramePreviews();
  revialInitProductCarousels();
  revialInitProductForms();
  revialInitGalleryWalls();
  revialInitEditions();
  revialInitModelViewerLoader();
  revialInitAugmentedReality();
  revialInitCookieConsent();
  revialInitEmailPopup();
  revialInitAnalyticsEvents();
});
